import api from '../../lib/api';
import type { AxiosRequestConfig } from 'axios';
import type { Attachment, InitUploadReq, InitUploadRes } from './types';

export const attachmentsApi = {
  init: (req: InitUploadReq, config?: AxiosRequestConfig) =>
    api.post<InitUploadRes>('/attachments/init', req, config).then((r) => r.data),

  complete: (attachmentId: string, config?: AxiosRequestConfig) =>
    api.post<Attachment>(`/attachments/${attachmentId}/complete`, undefined, config).then((r) => r.data),

  /** Upload vía API (mismo origen). Evita presigned PUT roto tras rewrite /storage en NPM. */
  upload: (
    attachmentId: string,
    file: File,
    onProgress?: (pct: number) => void,
    config?: AxiosRequestConfig,
  ): Promise<void> =>
    api
      .put(`/attachments/${attachmentId}/upload`, file, {
        ...config,
        headers: { 'Content-Type': file.type || 'application/octet-stream', ...config?.headers },
        timeout: 600_000,
        onUploadProgress: (ev) => {
          if (onProgress && ev.total) {
            onProgress(Math.round((ev.loaded / ev.total) * 100));
          }
        },
      })
      .then(() => undefined),

  listByResource: (resourceType: string, resourceId: string) =>
    api
      .get<Attachment[]>('/attachments', { params: { resourceType, resourceId } })
      .then((r) => r.data),

  /** Stream vía API (mismo origen /api) — no expone MinIO al browser. */
  download: async (id: string, fileName: string): Promise<void> => {
    const { data } = await api.get<Blob>(`/attachments/${id}/download`, {
      responseType: 'blob',
    });
    const url = URL.createObjectURL(data);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();
    URL.revokeObjectURL(url);
  },

  remove: (id: string) => api.delete(`/attachments/${id}`).then(() => undefined),
};
